export const Mail = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
      stroke="url(#paint0_linear_10075_167806)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 6L12 13L2 6"
      stroke="url(#paint1_linear_10075_167806)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_10075_167806"
        x1="2"
        y1="3.99999"
        x2="24.504"
        y2="9.2343"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0E4ED7" />
        <stop offset="0.484375" stopColor="#7B4B93" />
        <stop offset="1" stopColor="#F94743" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_10075_167806"
        x1="2"
        y1="5.99999"
        x2="20.4942"
        y2="15.8323"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0E4ED7" />
        <stop offset="0.484375" stopColor="#7B4B93" />
        <stop offset="1" stopColor="#F94743" />
      </linearGradient>
    </defs>
  </svg>
);
